import { getLocationBasedEventsFlag } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export const useShowLocationBasedEvents = (tenantId: string) => {
  const { data, status } = useQuery(
    ['show-location-based-events', tenantId],
    () => getLocationBasedEventsFlag(tenantId)
  );

  return {
    showLocationBasedEvents: data,
    showLocationBasedEventsStatus: status,
  };
};
